import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import { useCoarsePointer } from '#/modules/commonComponents/hint/useCoarsePointer';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '#/modules/commonComponents/popover';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '#/modules/commonComponents/tooltip';

/**
 * 桌面（fine pointer）：Tooltip（延遲由 TooltipProvider，預設 500ms）。
 * 觸控（pointer: coarse）：Popover 點開／點關。
 */
const ResponsiveHint = ({
  content,
  side = 'top',
  contentClassName,
  children,
}) => {
  const isCoarsePointer = useCoarsePointer();

  if (isCoarsePointer) {
    return (
      <Popover>
        <PopoverTrigger asChild>
          {children}
        </PopoverTrigger>
        <PopoverContent
          side={side}
          align="center"
          className={cn('w-auto max-w-xs p-2 text-xs', contentClassName)}
        >
          {content}
        </PopoverContent>
      </Popover>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {children}
      </TooltipTrigger>
      <TooltipContent side={side} className={cn('max-w-xs', contentClassName)}>
        {content}
      </TooltipContent>
    </Tooltip>
  );
};

ResponsiveHint.propTypes = {
  content: PropTypes.node.isRequired,
  side: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  contentClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default ResponsiveHint;
